// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3iCjT","title":"Images45_title__3UDBr","images":"Images45_images__4AWDJ"};